export default function toBeautifulDecimal(number) {
  return Number.isInteger(number) ? number.toString() : number.toFixed(2);
}